import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

const base = {
  p: ({ children }) => <p className="mb-5 last:mb-0 leading-[1.85]">{children}</p>,
  h1: ({ children }) => <h2 className="font-serif text-2xl sm:text-3xl mt-8 mb-4" style={{ color: "var(--burgundy)" }}>{children}</h2>,
  h2: ({ children }) => <h3 className="font-serif text-xl sm:text-2xl mt-8 mb-3" style={{ color: "var(--burgundy)" }}>{children}</h3>,
  h3: ({ children }) => <h4 className="font-serif text-lg mt-6 mb-2" style={{ color: "var(--burgundy)" }}>{children}</h4>,
  blockquote: ({ children }) => (
    <blockquote className="my-6 pl-5 border-l-2 font-serif italic text-lg leading-relaxed" style={{ borderColor: "var(--gold)" }}>{children}</blockquote>
  ),
  ul: ({ children }) => <ul className="mb-5 pl-5 list-disc space-y-1.5">{children}</ul>,
  ol: ({ children }) => <ol className="mb-5 pl-5 list-decimal space-y-1.5">{children}</ol>,
  a: ({ href, children }) => <a href={href} target="_blank" rel="noreferrer" className="ink-link underline" style={{ color: "var(--burgundy)" }}>{children}</a>,
  strong: ({ children }) => <strong className="font-semibold" style={{ color: "var(--burgundy)" }}>{children}</strong>,
  hr: () => <div className="hairline my-8" />,
};

export const Markdown = ({ children, className = "", style }) => {
  if (!children) return null;
  return (
    <div className={`text-base ${className}`} style={style}>
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]} components={base}>{children}</ReactMarkdown>
    </div>
  );
};
